module.exports = __webpack_public_path__ + "img/86.4.NH3-N.1cecfaac.png";